import { globalRouters } from '@/utils/const'
// import { useDocumentTitle } from '@/hooks'
// import { TransitionGroup, CSSTransition } from 'react-transition-group'
// import Main from '@/pages/Main'
// import Cart from '@/pages/Cart/index'
// import Detail from '@/pages/Detail/index'
import { genNonDuplicateID } from '@/utils/utils'
import { lazy } from 'react'
import CacheRoute, { CacheSwitch, clearCache, getCachingKeys } from 'react-router-cache-route'
// import lazy from 'react-lazy-with-preload'
// import { BrowserRouter as Router, Switch, Route, withRouter } from 'react-router-dom'
// @ts-ignore
import { Route, withRouter } from 'react-router-dom'
const Main = lazy(() => import('@/pages/Main'))
const MainV2 = lazy(() => import('@/pages/MainV2'))
const Cart = lazy(() => import('@/pages/Cart/index'))
const Detail = lazy(() => import('@/pages/Detail/index'))
const AddOn = lazy(() => import('@/pages/AddOn/index'))
const Comment = lazy(() => import('@/pages/Comment/index'))
const Classify = lazy(() => import('@/pages/Classify'))
const Collection = lazy(() => import('@/pages/Collection'))
const SearchResult = lazy(() => import('@/pages/SearchResult'))
const Tags = lazy(() => import('@/pages/Tags'))
const Prefecture = lazy(() => import('@/pages/Prefecture'))
const ClassifyTag = lazy(() => import('@/pages/ClassifyTag'))
// const PayResult = lazy(() => import('@/pages/PayResult'))
const PayResult11 = lazy(() => import('@/pages/PayResult11'))
const PayResultSale = lazy(() => import('@/pages/PayResultSale'))
const CustomPayResult = lazy(() => import('@/pages/CustomPayResult'))
const ActRules = lazy(() => import('@/pages/ActRules'))
const Redemption = lazy(() => import('@/pages/Redemption'))
const Confirm = lazy(() => import('@/pages/Confirm'))
const Address = lazy(() => import('@/pages/Address'))
const Update = lazy(() => import('@/pages/Address/Update'))
const Create = lazy(() => import('@/pages/Address/Create'))
const Protocol = lazy(() => import('@/pages/Protocol'))
const Paying = lazy(() => import('@/pages/Paying'))
const Licence = lazy(() => import('@/pages/Licence'))
const Discount = lazy(() => import('@/pages/Discount'))
const Mine = lazy(() => import('@/pages/Mine'))
const Orders = lazy(() => import('@/pages/Orders'))
const Evaluate = lazy(() => import('@/pages/Evaluate'))
const Setting = lazy(() => import('@/pages/Setting'))
const ExpressInfo = lazy(() => import('@/pages/ExpressInfo'))
const OrderDetail = lazy(() => import('@/pages/OrderDetail'))
const ActionsResult = lazy(() => import('@/pages/ActionsResult'))
const HelpPay = lazy(() => import('@/pages/HelpPay'))
const PayCode = lazy(() => import('@/pages/PayCode'))
const HelpPayDetail = lazy(() => import('@/pages/HelpPayDetail'))
const Activitys = lazy(() => import('@/pages/Activitys'))
const CopperInstru = lazy(() => import('@/pages/CopperInstru'))
const Tools = lazy(() => import('@/pages/Tools'))
// const WishList = lazy(() => import('@/pages/WishList'))
const Books = lazy(() => import('@/pages/WishList/Books'))
const GoodList = lazy(() => import('@/pages/WishList/GoodList'))
const Rules = lazy(() => import('@/pages/WishList/Rules'))

//Redemption
// const Main = lazy(() => import(/* webpackChunkName: "home" */ '@/pages/Main'))
// const Cart = lazy(() => import(/* webpackChunkName: "Cart" */ '@/pages/Cart/index'))
// const Detail = lazy(() => import(/* webpackChunkName: "Detail" */ '@/pages/Detail/index'))

// @ts-ignore
window.clearCache = clearCache
// @ts-ignore
window.getCachingKeys = getCachingKeys
const ROUTES_ARR = [
  {
    path: '/',
    component: Main,
    sceneConfig: {
      enter: 'from-right',
      exit: 'to-right',
    },
  },
  {
    path: '/homeV2',
    component: MainV2,
  },
  {
    path: '/cart',
    component: Cart,
  },
  {
    path: '/redemption',
    component: Redemption,
  },

  //商详页
  {
    path: '/detail/:itemId',
    component: Detail,
  },
  {
    path: '/copper-instruction',
    component: CopperInstru,
  },
  {
    path: '/tools',
    component: Tools,
  },
  //评论页
  {
    path: '/comment/:itemId',
    component: Comment,
  },
  //凑单页
  {
    path: '/addon',
    component: AddOn,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },
  //分类页
  {
    path: '/classify',
    component: Classify,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },
  //合集页面
  {
    path: '/collection',
    component: Collection,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },

  //搜索结果页
  {
    path: '/result',
    component: SearchResult,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },

  //标签页
  {
    path: '/tags',
    component: Tags,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },
  //Prefecture
  {
    path: '/prefecture',
    component: Prefecture,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },

  {
    path: '/classify-tag',
    component: ClassifyTag,
    keepLive: {
      multiple: 8,
      when: 'always',
    },
  },
  //PayResult
  {
    path: '/pay-result',
    component: CustomPayResult,
  },
  // {
  //   path: '/pay-result',
  //   component: PayResult,
  // },
  {
    path: '/pay-result11',
    component: PayResult11,
  },
  {
    path: '/pay-result-sale',
    component: PayResultSale,
  },
  {
    path: '/act-rules',
    component: ActRules,
  },
  {
    path: '/confirm',
    component: Confirm,
  },
  {
    path: '/protocol',
    component: Protocol,
  },
  {
    path: '/address',
    component: Address,
  },
  {
    path: '/address/create',
    component: Create,
  },
  {
    path: '/address/edit',
    component: Update,
  },
  {
    path: '/paying/:orderId',
    component: Paying,
  },

  {
    path: '/licence',
    component: Licence,
  },
  {
    path: '/discount/:activityId',
    component: Discount,
  },
  {
    path: '/mine',
    component: Mine,
  },
  {
    path: '/orders',
    component: Orders,
  },
  {
    path: '/evaluate/:orderId',
    component: Evaluate,
  },
  {
    path: '/setting',
    component: Setting,
  },
  {
    path: '/express/:orderId',
    component: ExpressInfo,
  },
  {
    path: '/order-detail/:orderId',
    component: OrderDetail,
  },
  {
    path: '/help-pay/:orderId',
    component: HelpPay,
  },
  {
    path: '/help-pay-detail/:orderId',
    component: HelpPayDetail,
  },

  {
    path: '/pay-code/:orderId',
    component: PayCode,
  },
  {
    path: '/action-result',
    component: ActionsResult,
  },

  {
    path: '/activitys',
    component: Activitys,
  },
  {
    path: '/wish/books',
    component: Books,
  },
  {
    path: '/wish/goodslist',
    component: GoodList,
  },
  {
    path: '/wish/rules',
    component: Rules,
  },
]

const RouteConfig = withRouter(({ location, history }) => {
  let cur = null
  if (history.action === 'POP') {
    if (globalRouters.length < 1) {
      cur = {
        key: genNonDuplicateID(),
      }
      globalRouters.push(cur)
    } else {
      globalRouters.pop()
    }
  } else {
    cur = {
      key: genNonDuplicateID(),
    }
    globalRouters.push(cur)
  }

  const _router = globalRouters[globalRouters.length - 1] || {}
  const key = _router.key
  location.key = key
  return (
    <CacheSwitch location={location}>
      {ROUTES_ARR.map((config, index) => {
        if (config.keepLive) {
          return (
            // @ts-ignore
            <CacheRoute
              key={index}
              exact
              {...config.keepLive}
              path={config.path}
              component={config.component}
            />
          )
        }
        return <Route exact location={{ ...location }} key={index} {...config} />
      })}
    </CacheSwitch>
  )
})
// Cart.preload()
// Detail.preload()
// AddOn.preload()

export { RouteConfig }
// export function RouteConfig() {

// }
